import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './fussballdewidget.module.css'
function createElementFromHTML(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.firstChild;
}

const forceReload = (link) => {
    return (
        link === "/unser-verein/sportlerbar" ||
        link === "/mannschaftssport/fußball" ||
        link.startsWith("/mannschaftssport/fußball/")
    );
};

const matchPlan = `<div
        class="fussballde_widget"
        data-id="1203a3c5-5ea8-41b5-980a-c324d588a750"
        data-type="club-matches"
    ></div>`

const FussballWidget = ({ htmlString, isMatchPlan = false }) => {
    const containerRef = useRef(null);
    const location = useLocation();
    const effectiveHtml = isMatchPlan && !htmlString ? matchPlan : htmlString;
    // Auto-detect widget provider
    const detectWebsite = (div) => {
        if (!div) return null;

        if (div.classList?.contains('fussballde_widget')) return 'fussball.de';
        if (div.id?.startsWith('fp-widget_root')) return 'fupa.de';

        return null;
    };

    useEffect(() => {
        if (!effectiveHtml || !containerRef.current) return;
        // Parse HTML string into a DOM element
        const div = createElementFromHTML(effectiveHtml);
        if (!div) {
            console.warn('Could not parse widget HTML string.');
            return;
        }

        const website = detectWebsite(div);
        if (!website) {
            console.warn('Unknown widget provider for:', div);
            return;
        }

        // Clear container and append parsed div
        containerRef.current.innerHTML = '';
        containerRef.current.appendChild(div);

        // Determine correct script URL
        let scriptUrl = '';
        if (website === 'fussball.de') {
            scriptUrl = 'https://www.fussball.de/widgets.js';
        } else if (website === 'fupa.de') {
            scriptUrl = 'https://widget-api.fupa.net/vendor/widget.js?v1';
        }

        const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);

        const initializeWidget = () => {
            if (website === 'fupa.de' && window.Widget?.init) {
                window.Widget.init();
            } else if (website === 'fussball.de' && window.fussballdeWidgetsInit) {
                window.fussballdeWidgetsInit();
            }
        };

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = scriptUrl;
            script.async = true;
            script.onload = initializeWidget;
            document.body.appendChild(script);
        } else {
            setTimeout(() => {
                initializeWidget();
            }, 0);
        }
    }, [location.pathname, effectiveHtml]);
    return <div className={styles.widgetContainer} ref={containerRef} />;
};

export { FussballWidget, forceReload };
